import React, { useState } from 'react';

import { Flex, useTheme } from '@chakra-ui/react';
import { OKRCheckinExitModificationsModal as CustomMetricExitModificationsModal } from 'components/RabbitOKRSidePanel/Components/OKRCheckinExitModifications';
import { closeCheckInPanel } from 'components/RabbitOKRSidePanel/krDrawerSecondaryPanelSlice';
import { useDispatch } from 'react-redux';

import { Button } from 'uiToolkitV1/Button';
import { Tooltip } from 'uiToolkitV1/Tooltip';

export const PluginPanelFooter = ({ isModified = false, isDisabled = true, disabledReason = '', onSave }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [isExitModalOpen, setIsExitModalOpen] = useState(false);

  const onCancelExitModificationModal = () => {
    setIsExitModalOpen(false);
  };

  const handleCancelClick = () => {
    if (isModified) {
      setIsExitModalOpen(true);
    } else {
      dispatch(closeCheckInPanel());
    }
  };

  const handleDiscardModifications = () => {
    dispatch(closeCheckInPanel());
  };

  return (
    <Flex
      flex="auto 0 0"
      borderTopWidth="1px"
      h="72px"
      justifyContent="flex-end"
      alignItems="center"
      backgroundColor={theme.colors.neutral.F5F7F9}
      px={4}
      py={3}
    >
      <Button variant="tertiary" mr="auto" onClick={handleCancelClick}>
        Cancel
      </Button>

      <Tooltip fontSize="14px" label={disabledReason} shouldWrapChildren>
        <Button variant="filled" colorScheme="blue" onClick={onSave} disabled={isDisabled}>
          Save
        </Button>
      </Tooltip>

      <CustomMetricExitModificationsModal
        isOpen={isExitModalOpen}
        onCancel={onCancelExitModificationModal}
        onExitConfirmation={handleDiscardModifications}
      />
    </Flex>
  );
};
